import React from "react";
import { graphql, useFragment } from "react-relay";

import { faFilePlus } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import { useMergeStreamModal } from "~/notes/MergeStream";

import {
	MenuItemToBeDisabledForExternalWorkspaces,
	MenuItemTooltip,
	useGetPropsForExternalWorkspaces,
} from "./MenuItemTooltip";

import type { MergeSeries_note$key } from "~/__generated__/MergeSeries_note.graphql";
import type { MergeSeries_viewer$key } from "~/__generated__/MergeSeries_viewer.graphql";

const viewerFragment = graphql`
	fragment MergeSeries_viewer on Viewer {
		user {
			id
		}
	}
`;

const noteFragment = graphql`
	fragment MergeSeries_note on Note {
		stream {
			id
			displayName
			notestreamusers {
				user {
					id
				}
				accessType
			}
		}
		...MenuItemTooltip_useGetPropsForExternalWorkspaces_note
	}
`;

export default function MergeSeriesMenuItem({
	note: noteKey,
	viewer: viewerKey,
}: {
	note: MergeSeries_note$key;
	viewer: MergeSeries_viewer$key;
}) {
	const viewer = useFragment(viewerFragment, viewerKey);
	const note = useFragment(noteFragment, noteKey);
	const openMergeModal = useMergeStreamModal(note.stream);
	const tooltipPropsForExternalWorkspaces = useGetPropsForExternalWorkspaces(note);

	const currentUserMember = note.stream.notestreamusers.find(nsu => nsu.user.id === viewer.user.id);
	const menuItemDisabled = !currentUserMember || !["full", "shared"].includes(currentUserMember.accessType);

	return (
		<MenuItemToBeDisabledForExternalWorkspaces
			onSelect={openMergeModal}
			icon={faFilePlus}
			disabled={menuItemDisabled}
			{...tooltipPropsForExternalWorkspaces}
		>
			<MenuItemTooltip content="Full series access required" disabled={!menuItemDisabled}>
				<span>Merge…</span>
			</MenuItemTooltip>
		</MenuItemToBeDisabledForExternalWorkspaces>
	);
}
